export default __webpack_public_path__ + "static/media/ic_timer.3d514740.svg";